import { useQuery } from '@tanstack/react-query';
import { Connection, EntraMapping, EntraRunList, EntraStatus } from '@cloudsign/shared';
import { z } from 'zod';
import { api } from '../../lib/api';

export const ConnectionList = z.array(Connection);
export const MappingList = z.array(EntraMapping);

export const connectionsKey = ['integrations', 'connections'] as const;
export const entraKey = ['integrations', 'entra'] as const;
export const mappingsKey = ['integrations', 'entra', 'mappings'] as const;
export const runsKey = ['integrations', 'entra', 'runs'] as const;

export function useConnections(enabled = true) {
  return useQuery({ queryKey: connectionsKey, enabled, retry: false, queryFn: () => api.get('/integrations/connections', { schema: ConnectionList }) });
}
export function useEntraStatus() {
  return useQuery({ queryKey: entraKey, queryFn: () => api.get('/integrations/entra', { schema: EntraStatus }) });
}
export function useMappings(enabled: boolean) {
  return useQuery({ queryKey: mappingsKey, enabled, queryFn: () => api.get('/integrations/entra/mappings', { schema: MappingList }) });
}
export function useRuns(enabled: boolean) {
  return useQuery({ queryKey: runsKey, enabled, queryFn: () => api.get('/integrations/entra/runs', { query: { pageSize: 10 }, schema: EntraRunList }) });
}
